import { en } from './en';
import { no } from './no';

// Compile-time assertion: both files must have identical key sets
type EnKeys = keyof typeof en;
type NoKeys = keyof typeof no;
type _AssertSameKeys = [EnKeys] extends [NoKeys] ? ([NoKeys] extends [EnKeys] ? true : never) : never;
const _check: _AssertSameKeys = true;
void _check;

export const messages = {
	en,
	no,
};

export type Locale = keyof typeof messages;

export const defaultLocale: Locale = 'en';
